import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { SignInProvider } from "./components/context/SignInContext";
import { UserProvider } from "./components/context/UserContext";
import { CardProvider } from "./components/context/CardContext";

ReactDOM.render(
	<SignInProvider>
		<UserProvider>
			<CardProvider>
				<BrowserRouter>
					<React.StrictMode>
						<App />
					</React.StrictMode>
				</BrowserRouter>
			</CardProvider>
		</UserProvider>
	</SignInProvider>,
	document.getElementById("root")
);
